import React from 'react';
import { FONTS } from 'styles/theme';
import { PREMIUM_SURCHARGE } from 'constants/meals';

const TIERS = [
  { key: 'standard', label: 'Standard' },
  { key: 'premium', label: 'Organic · Wild-caught · Grass-fed' },
];

/**
 * Standard / premium protein choice for one meal type. Without `onChange` it
 * shows only the selected tier, read-only.
 */
export default function ProteinTier({ premium, onChange }) {
  return (
    <div>
      <div style={{ fontSize: '11px', letterSpacing: '1.5px', color: '#8a8580', fontWeight: 500, marginBottom: '8px' }}>PROTEIN</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', gap: '8px' }}>
        {TIERS.map((t) => {
          const on = (t.key === 'premium') === premium;
          if (!onChange && !on) return null;
          return (
            <button key={t.key} type="button" disabled={!onChange} aria-pressed={on} onClick={() => onChange?.(t.key === 'premium')} style={{
              width: '100%', boxSizing: 'border-box', minWidth: 0, overflowWrap: 'anywhere', touchAction: 'manipulation', padding: '11px 12px', borderRadius: '10px', fontSize: t.key === 'standard' ? '14px' : '12px', fontFamily: FONTS.sans,
              color: '#2b2b2b', textAlign: 'center', border: `1px solid ${on ? '#e8c86a' : '#dcd8d0'}`,
              background: on ? '#fbf1d9' : '#fff', cursor: onChange ? 'pointer' : 'default',
            }}>
              {t.label} <br/>{t.key === 'premium' ? ` (+$${PREMIUM_SURCHARGE.toFixed(2)} / meal)` : ''}
            </button>
          );
        })}
      </div>
    </div>
  );
}
